<template>
  <div
    v-if="$rsGlobals.$isTranslateMode"
    class="rs-translation-badge"
    title="Language you currently editing data for"
  >
    <RsIcon icon="language" />
    <span class="lang-text">{{ $rsGlobals.$language.toUpperCase() }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsTranslationBadge',
});
</script>

<style lang="scss" scoped>
.rs-translation-badge {
  display: inline-flex;
  align-items: center;
  margin-left: 1rem;
  .lang-text{
    margin-left: 0.5rem;
  }
}

</style>
